import React from "react";
import { Container, Eyebrow, PhotoBand } from "@/components/site/ui";

// Cabeçalho das páginas internas: foto real com véu + título editorial.
const PageHeader = ({ eyebrow, title, lead, lead2, img, alt, testId, veil = 0.72 }) => (
    <section data-testid={testId} data-section-id="header" className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden">
        <PhotoBand src={img} alt={alt} veil={veil} className="absolute inset-0" />
        <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-[#0E2018]" />
        <Container className="relative">
            <div className="max-w-3xl animate-fade-up">
                <Eyebrow>{eyebrow}</Eyebrow>
                <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.015em] text-[#F2EFE5] text-balance">
                    {title}
                </h1>
                {lead && (
                    <p className="mt-7 font-sans font-light text-[15px] md:text-[17px] leading-[1.75] text-[#D7D1BF] max-w-2xl">{lead}</p>
                )}
                {lead2 && (
                    <p className="mt-5 font-sans font-light text-[15px] md:text-[17px] leading-[1.75] text-[#D7D1BF] max-w-2xl">{lead2}</p>
                )}
            </div>
        </Container>
    </section>
);

export default PageHeader;
